import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
//
//import DeliveryLocations from './../Components/DeliveryLocations'
//
import AccountResources from './../Account/Resources/commonfunctions.js';

//
let service = new services();

export default {
    name: 'ShoppingList',
    mixins: [AccountResources],
    data () {
        return {
            //
            headerdata:{
                'name':'Shopping List',
            },
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
       // 'component-delivery-locations': DeliveryLocations
    },
    methods: {

        preset() {
            this.loading = true;
            
            //../
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                    //
                    self.getOrders(self.user.user_id);
                }else {
                    self.loading = false;
                    //self.$router.push('/login')
                }
            });
            
        },

        setPresetCategories(){
            var payload = {}
            this.getPresetCategories(payload);
        },

        setBusinessView(business){
            this.sellpoint = business;
            //get the products
            this.setMenuTabInnerView('getCategoryProducts');
        },

        setProductView(product){
            this.product = product;
            //get the products
            if(Object.keys(this.product.product_items).length > 1){
                this.toggleSingleComponent('productItemsBox');
            }else{
                //add to selected array
            }
        },

        //refac
        setMarketActivities(){
            service.getMarketActivityProducts(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market_trending = response.body.data; 
                    this.products = response.body.data; 
                }
            }).catch((err) => {})
        },

        setMarketRemote(){
            service.getBusinessByUserName(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market = response.body.data; 
                    this.businesses = this.market.business_markets;
                    this.loading = false;
                }
            }).catch((err) => {})
        },
    },
    created: function(){
        this.setMarketRemote();
        this.setMarketActivities();
        this.setPresetCategories();
        this.preset();
        //
        
        if(this.$route.path == '/shopping/lists/new'){
            this.setMenuTabInnerView("newShoppingList");
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/ShoppingLists/script.js